<template>
  <div class="infoBox" ref="Box">
    <div class="s">
      <div class="TopTitle p-2">
        <div class="btns">
          <a @click="closeBox">X</a>
        </div>
        <h4>在线交流</h4>
      </div>
      <div class="p-2 infos">
        <p>
          联系电话：
          <br />0086-578-3168666
        </p>
        <p>
          邮箱：
          <br />Sales@pioneertools.com
        </p>
      </div>
      <div class="p-2 qrcode" style="text-align:center">
        <p>
          <span class="iconfont icon-liuyan"></span>
          微信公众号：
        </p>
        <b-img :src="qrimg" style="width:75%;margin:0 auto"></b-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qrimg: require("../../static/Updatedimg/QRcode.jpg"),
    };
  },
  methods: {
    closeBox() {
      this.$refs.Box.style.display = "none";
    },
  },
};
</script>

<style>
.infoBox {
  width: 200px;
  height: 340px;
  /* border: 1px solid #eee; */
  box-shadow: 3px 3px 3px #000;
  position: absolute;
  top: 80px;
  right: 0;
  margin: 0 40px;
  background: #fff;
  opacity: 0.9;
  border-radius: 15px;
  transition: all 0.5s ease-out;
  z-index: 999;
}
</style>

<style scoped>
.TopTitle {
  width: 100%;
  background: #015eb2;
}
.TopTitle h4 {
  color: aliceblue;
  padding: 5px;
}
.TopTitle .btns a {
  right: 10px;
  position: absolute;
  color: #fff;
}
.infos {
  font-size: 16px;
  color: #000;
  padding-bottom: 0rem !important;
}
</style>
